/**
 * @file 设置 rem 基础字体大小
 * @author zhuwenyi
 */
export function initRem(designWidth = 1440, baseFontSize = 16, min = 10, max = 19) {
    function update() {
        const screenWidth = document.documentElement.offsetWidth;
        let fontSize = (screenWidth / designWidth) * baseFontSize;
        fontSize = Math.max(min, Math.min(max, fontSize));
        document.documentElement.style.fontSize = fontSize + 'px';
    }

    update();
    window.addEventListener('resize', update);

    // 可选：返回一个销毁方法，避免多次绑定
    return () => window.removeEventListener('resize', update);
}
